import { render, staticRenderFns } from "./DemenagementStepsPopin.vue?vue&type=template&id=06345edb&"
import script from "./DemenagementStepsPopin.vue?vue&type=script&lang=js&"
export * from "./DemenagementStepsPopin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06345edb')) {
      api.createRecord('06345edb', component.options)
    } else {
      api.reload('06345edb', component.options)
    }
    module.hot.accept("./DemenagementStepsPopin.vue?vue&type=template&id=06345edb&", function () {
      api.rerender('06345edb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/broadband/internet/demenagement/fragments/DemenagementStepsPopin.vue"
export default component.exports